const icon = require('vue-svgicon');
icon.register({
    'caret-right_': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M24.342 14.858L9.952.472a1.621 1.621 0 00-2.288 0 1.613 1.613 0 000 2.283L20.913 16 7.666 29.244a1.615 1.615 0 000 2.284c.632.63 1.656.63 2.288 0l14.39-14.386a1.628 1.628 0 00-.002-2.283z"/>`,
    },
});
